import { render, staticRenderFns } from "./SettingsPopoverItem.vue?vue&type=template&id=6d562f08&"
import script from "./SettingsPopoverItem.vue?vue&type=script&lang=js&"
export * from "./SettingsPopoverItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports